import { travel, axiosConfig } from 'api';

import { DataTravelReason, TravelForm, TravelReason } from 'models/travelReseller';
import { Response } from 'models/response';

/* TRAVEL REASON */
export const saveTravelReason = async (travelReason: TravelForm): Promise<TravelForm> => {
  try {
    const response = await travel.post<Response<TravelForm>>(
      '/Travels/CreateReasonsForTravel',
      {
        companyId: travelReason.companyId,
        name: [
          { language: 'ES', value: travelReason.spanish },
          { language: 'PT', value: travelReason.portuguese },
          { language: 'EN', value: travelReason.english },
        ],
      },
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const updateTravelReason = async (travelReason: TravelForm): Promise<TravelForm> => {
  try {
    const response = await travel.put<Response<TravelForm>>(
      `/Travels/UpdateReasonsForTravel/${travelReason.id}`,
      {
        id: travelReason.id,
        companyId: travelReason.companyId,
        name: [
          { language: 'ES', value: travelReason.spanish },
          { language: 'PT', value: travelReason.portuguese },
          { language: 'EN', value: travelReason.english },
        ],
      },
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTravelReason = async (travelReasonId: string): Promise<DataTravelReason> => {
  try {
    const response = await travel.get<Response<DataTravelReason>>(
      `/travels/GetReasonsForTravel/${travelReasonId}`,
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTravelReasonList = async (): Promise<TravelReason[]> => {
  try {
    const response = await travel.get<Response<TravelReason[]>>('/Travels/GetReasonsForTravel', axiosConfig);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteTravelReason = async (reasonId?: string): Promise<string> => {
  try {
    const response = await travel.delete(`Travels/DeleteReasonsForTravel/${reasonId}`);

    if (response.status === 204 || response.status === 200) {
      return 'ok';
    } else {
      throw new Error('Unexpected response code');
    }
  } catch (error) {
    throw error;
  }
};

/* REJECTED REASON */
export const saveRejectedReason = async (travelReason: TravelForm): Promise<TravelForm> => {
  try {
    const response = await travel.post<Response<TravelForm>>(
      '/Travels/CreateRejectedReasonsForTravel',
      {
        companyId: travelReason.companyId,
        name: [
          { language: 'ES', value: travelReason.spanish },
          { language: 'PT', value: travelReason.portuguese },
          { language: 'EN', value: travelReason.english },
        ],
      },
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const updateRejectedReason = async (travelReason: TravelForm): Promise<TravelForm> => {
  try {
    const response = await travel.put<Response<TravelForm>>(
      `/Travels/UpdateRejectedReasonsForTravel/${travelReason.id}`,
      {
        id: travelReason.id,
        companyId: travelReason.companyId,
        name: [
          { language: 'ES', value: travelReason.spanish },
          { language: 'PT', value: travelReason.portuguese },
          { language: 'EN', value: travelReason.english },
        ],
      },
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getRejectedReason = async (rejectedReasonId: string): Promise<DataTravelReason> => {
  try {
    const response = await travel.get<Response<DataTravelReason>>(
      `/travels/GetRejectedReasonForTravel/${rejectedReasonId}`,
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getRejectedReasonList = async (): Promise<TravelReason[]> => {
  try {
    const response = await travel.get<Response<TravelReason[]>>('/Travels/GetRejectedReasonsForTravel', axiosConfig);
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const deleteRejectedReason = async (reasonId?: string): Promise<string> => {
    try {
      const response = await travel.delete(`Travels/DeleteRejectedReasonsForTravel/${reasonId}`);
  
      if (response.status === 204 || response.status === 200) {
        return 'ok';
      } else {
        throw new Error('Unexpected response code');
      }
    } catch (error) {
      throw error;
    }
  };

  /*BREAK RULES REASON  */

  export const saveBreakRulesReason = async (travelReason: TravelForm): Promise<TravelForm> => {
    try {
      const response = await travel.post<Response<TravelForm>>(
        '/Travels/CreateBreakRulesReasons',
        {
          companyId: travelReason.companyId,
          name: [
            { language: 'ES', value: travelReason.spanish },
            { language: 'PT', value: travelReason.portuguese },
            { language: 'EN', value: travelReason.english },
          ],
        },
        axiosConfig,
      );
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };
  export const updateBreakRulesReason = async (travelReason: TravelForm): Promise<TravelForm> => {
    try {
      const response = await travel.put<Response<TravelForm>>(
        `/Travels/UpdateBreakRulesReasons/${travelReason.id}`,
        {
          id: travelReason.id,
          companyId: travelReason.companyId,
          name: [
            { language: 'ES', value: travelReason.spanish },
            { language: 'PT', value: travelReason.portuguese },
            { language: 'EN', value: travelReason.english },
          ],
        },
        axiosConfig,
      );
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };
  
  export const getBreakRulesReason = async (rejectedReasonId: string): Promise<DataTravelReason> => {
    try {
      const response = await travel.get<Response<DataTravelReason>>(
        `/travels/GetBreakRulesReason/${rejectedReasonId}`,
        axiosConfig,
      );
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };
  
  export const getBreakRulesReasonList = async (): Promise<TravelReason[]> => {
    try {
      const response = await travel.get<Response<TravelReason[]>>('/Travels/GetBreakRulesReasons', axiosConfig);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };
  export const deleteBreaRulesReason = async (reasonId?: string): Promise<string> => {
      try {
        const response = await travel.delete(`Travels/DeleteBreakRulesReasons/${reasonId}`);
    
        if (response.status === 204 || response.status === 200) {
          return 'ok';
        } else {
          throw new Error('Unexpected response code');
        }
      } catch (error) {
        throw error;
      }
    };
  